import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

/**
 * App-wide change broadcast used for cross-feature notifications.
 *
 * Known payload shapes (consumers check for the field they care about):
 * - Plan change: `{ plan: string; planStatus?: string }` or `{ planObj: SubscriptionPlan }`
 *   (auth/billing flows → menu, admin-layout, settings)
 *
 * `subjectNotifier` fires only for subscribers present at emit time;
 * `behaviourNotifier` replays the latest value to late subscribers.
 * Kept `any`-typed on purpose: payloads are heterogeneous and consumers
 * feature-detect fields — if you add a new shape, document it here.
 */
@Injectable({
  providedIn: "root",
})
export class NotifyService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subjectNotifier: Subject<any> = new Subject<any>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  behaviourNotifier: BehaviorSubject<any> = new BehaviorSubject(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  notifyAboutChange(param: any = "") {
    this.subjectNotifier.next(param);
    this.behaviourNotifier.next(param);
  }
}
